import { Icon, Link, Stack, Text } from '@cad-arc';
import { pick } from 'lodash';

type BaseProps = {
    fontSize?: string;
    'data-testid'?: string;
};

type LinkTextProps = (
    | { onClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void; href?: never }
    | { href: string; onClick?: never }
) &
    BaseProps;

export function LinkText(props: React.PropsWithChildren<LinkTextProps>): React.ReactElement {
    const linkProps = pick(props, ['onClick', 'href', 'data-testid']);

    return (
        <Link {...linkProps}>
            <Stack direction="row" alignItems="center">
                <Text color="brand" fontSize={props.fontSize ?? 'md'}>
                    {props.children}
                </Text>
                <Icon color="brand.default" aria-label="OpenNewWindow" icon="OpenNewWindow" />
            </Stack>
        </Link>
    );
}
